module.exports = __webpack_public_path__ + "static/media/marketplace.10042ea5.png";